/** Scalar `siteId` is a positive int32. */
export function requirePositiveSiteId(siteId: number | string): number {
  const raw = typeof siteId === 'string' ? siteId.trim() : siteId;
  const id = typeof raw === 'string' && raw !== '' ? Number(raw) : Number(raw);
  if (!Number.isInteger(id) || id <= 0) {
    throw new Error('Invalid site id');
  }
  return id;
}

/** Required ISO datetime query values (StartDateTime / EndDateTime). */
export function requireIsoDateTime(value: string, fieldName: string): string {
  const trimmed = value.trim();
  if (!trimmed || Number.isNaN(Date.parse(trimmed))) {
    throw new Error(`Invalid ${fieldName}`);
  }
  return trimmed;
}

/** Scalar create-incident `eventId` must be non-blank. */
export function requireNonBlankEventId(eventId: string): string {
  const trimmed = eventId.trim();
  if (!trimmed) {
    throw new Error('Invalid event id');
  }
  return trimmed;
}
